import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faEye, faX } from '@fortawesome/free-solid-svg-icons';

function Meetingpending() {
  const [meetings, setMeetings] = useState([]);
  const [error, setError] = useState(null);
  const [selectedId, setSelectedId] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedMeeting, setSelectedMeeting] = useState(null);
  const [fullscreenImage, setFullscreenImage] = useState(null);

  const api = process.env.REACT_APP_API;
  const UNIFORM_COST = 549;
  const MEETING_COST = 250;

  const fetchData = async () => {
    try {
      const response = await axios.get(`${api}/meeting/viewpending`);
      setMeetings(response.data);
    } catch (err) {
      console.error('Error fetching meetings:', err);
      setError('Failed to load meeting data');
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const getSizes = (sizes) => {
    try {
      if (Array.isArray(sizes)) return sizes.join(', ');
      const parsed = JSON.parse(sizes);
      return Array.isArray(parsed) ? parsed.join(', ') : parsed || '—';
    } catch {
      return sizes || '—';
    }
  };

  const handleAction = async (id) => {
    try {
      await axios.post(`${api}/meeting/approve/${id}`);
      fetchData();
    } catch (err) {
      console.log(err);
    }
  };

  const handleConfirmClick = (id) => {
    setSelectedId(id);
    setShowModal(true);
  };

  const handleConfirmYes = () => {
    handleAction(selectedId);
    setShowModal(false);
  };

  const handleConfirmNo = () => {
    setSelectedId(null);
    setShowModal(false);
  };

  const filteredMeetings = meetings.filter(
    (m) =>
      m.full_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      m.merchantOrderId?.toLowerCase().includes(searchTerm.toLowerCase())
  );
    

const handleReject = async (id) => {
  const confirmDelete = window.confirm("Are you sure you want to reject and delete this entry?");
  if (!confirmDelete) return;

  try {
    await axios.delete(`${api}/meeting/deletepending/${id}`);
    alert("Entry rejected and removed.");
    fetchData(); // Refresh the list
  } catch (error) {
    console.error("Failed to reject entry:", error);
    alert("Failed to delete entry. Please try again.");
  }
};


  return (
    <div style={{ padding: '30px', fontFamily: 'Segoe UI, sans-serif', backgroundColor: '#f9f9f9' }}>
      <h2 style={{ marginBottom: '20px' }}>🗓️ Meeting List</h2>

      <input
        type="text"
        placeholder="Search by name or order ID..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        style={{
          padding: '10px',
          marginBottom: '15px',
          width: '100%',
          maxWidth: '400px',
          fontSize: '14px',
          borderRadius: '6px',
          border: '1px solid #ccc',
        }}
      />

      {error && <p style={{ color: 'red' }}>{error}</p>}

      {meetings.length === 0 && !error ? (
        <p>Loading meetings...</p>
      ) : (
        <div style={{ overflowX: 'auto', border: '1px solid #ddd', borderRadius: '6px', backgroundColor: '#fff' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', minWidth: '1000px' }}>
            <thead>
              <tr style={{ backgroundColor: '#004080', color: '#fff' }}>
                {[
                  '#',
                  'Name',
                  'Username',
                  'Order ID',
                  'Phone',
                  'Aadhaar No',
                  'Designation',
                  'Amount',
                  // 'Paid',
                  'Uniform Qty',
                  'Sizes',
                  'Action',
                ].map((title, i) => (
                  <th key={i} style={thStyle}>
                    {title}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {filteredMeetings.map((meeting, index) => (
                <tr key={meeting.id} style={index % 2 === 0 ? rowEvenStyle : rowOddStyle}>
                  <td style={tdStyle}>{index + 1}</td>
                  <td style={tdStyle}>{meeting.full_name}</td>
                  <td style={tdStyle}>{meeting.username || '—'}</td>
                  <td style={tdStyle}>{meeting.merchantOrderId}</td>
                  <td style={tdStyle}>{meeting.phone}</td>
                  <td style={tdStyle}>{String(meeting.aadhaar_no)}</td>
                  <td style={tdStyle}>{meeting.designation || '—'}</td>
                  {/* <td style={tdStyle}>{(meeting.uniformQty || 0) * UNIFORM_COST + MEETING_COST}</td> */}
                  <td style={tdStyle}>{meeting.payAmount || '—'}</td>
                  <td style={tdStyle}>{meeting.uniformQty}</td>
                  <td style={tdStyle}>{getSizes(meeting.uniformSizes)}</td>
                  <td style={{display:'flex',justifyContent:'space-around',gap:"2px"}} >
                    <button
                      onClick={() => setSelectedMeeting(meeting)}
                      // style={{ backgroundColor: 'transparent', color: 'black', marginRight: '8px' }}
                    >
                      <FontAwesomeIcon icon={faEye} />
                    </button>
                    <button
                      style={{
                        ...buttonStyle,
                        backgroundColor: meeting.presented === 'yes' ? '#6c757d' : '#007bff',
                        cursor: meeting.presented === 'yes' ? 'not-allowed' : 'pointer',
                      }}
                      disabled={meeting.presented === 'yes'}
                      onClick={() => handleConfirmClick(meeting.merchantOrderId)}
                    >
                     <FontAwesomeIcon icon={faCheck} />
                    </button>

                    <button
                      style={{
                        ...buttonStyle,
                        backgroundColor: meeting.presented === 'yes' ? '#6c757d' : '#007bff',
                        cursor: meeting.presented === 'yes' ? 'not-allowed' : 'pointer',
                      }}
                      disabled={meeting.presented === 'yes'}
                      onClick={() => handleReject(meeting.id)}
                    >
                     <FontAwesomeIcon icon={faX} />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {/* Confirmation modal */}
      {showModal && (
        <div style={modalOverlayStyle}>
          <div style={modalStyle}>
            <p>
              Are you sure you want to approve order ID <b style={{ color: 'green' }}>{selectedId}</b>?
            </p>
            <div style={{ marginTop: '15px' }}>
              <button style={modalButtonStyle} onClick={handleConfirmYes}>
                Yes
              </button>
              <button style={{ ...modalButtonStyle, marginLeft: '10px' }} onClick={handleConfirmNo}>
                No
              </button>
            </div>
          </div>
        </div>
      )}

      {/* View Modal with full image click */}
      {selectedMeeting && (
        <div style={modalOverlayStyle}>
          <div style={modalStyle}>
            <h3 style={{ marginBottom: '10px', color: '#333' }}>Meeting Details</h3>
            <table style={{ width: '100%', fontSize: '14px', marginBottom: '10px' }}>
              <tbody>
                <tr>
                  <td>
                    <strong>Name:</strong>
                  </td>
                  <td>{selectedMeeting.full_name}</td>
                </tr>
                <tr>
                  <td>
                    <strong>Username:</strong>
                  </td>
                  <td>{selectedMeeting.username || '—'}</td>
                </tr>
                <tr>
                  <td>
                    <strong>Order ID:</strong>
                  </td>
                  <td>{selectedMeeting.merchantOrderId}</td>
                </tr>
                <tr>
                  <td>
                    <strong>Phone:</strong>
                  </td>
                  <td>{selectedMeeting.phone}</td>
                </tr>
                <tr>
                  <td>
                    <strong>Aadhaar:</strong>
                  </td>
                  <td>{String(selectedMeeting.aadhaar_no)}</td>
                </tr>
                <tr>
                  <td>
                    <strong>Designation:</strong>
                  </td>
                  <td>{selectedMeeting.designation || '—'}</td>
                </tr>
                <tr>
                  <td>
                    <strong>Pay Amount:</strong>
                  </td>
                  <td>{selectedMeeting.payAmount || '—'}</td>
                </tr>
                <tr>
                  <td>
                    <strong>Uniform Qty:</strong>
                  </td>
                  <td>{selectedMeeting.uniformQty}</td>
                </tr>
                <tr>
                  <td>
                    <strong>Uniform Sizes:</strong>
                  </td>
                  <td>{getSizes(selectedMeeting.uniformSizes)}</td>
                </tr>
                <tr>
                  <td>
                    <strong>Photo:</strong>
                  </td>
                  <td>
                    {selectedMeeting.photoPath ? (
                      <img
                        src={`${api}/uploads/${selectedMeeting.photoPath}`}
                        alt="photo"
                        style={{ width: '100px', cursor: 'pointer' }}
                        onClick={() => setFullscreenImage(`${api}/uploads/${selectedMeeting.photoPath}`)}
                      />
                    ) : (
                      '—'
                    )}
                  </td>
                </tr>
                <tr>
                  <td>
                    <strong>Payment Screenshot:</strong>
                  </td>
                  <td>
                    {selectedMeeting.paymentScreenshotPath ? (
                      <img
                        src={`${api}/uploads/${selectedMeeting.paymentScreenshotPath}`}
                        alt="screenshot"
                        style={{ width: '100px', cursor: 'pointer' }}
                        onClick={() => setFullscreenImage(`${api}/uploads/${selectedMeeting.paymentScreenshotPath}`)}
                      />
                    ) : (
                      '—'
                    )}
                  </td>
                </tr>
              </tbody>
            </table>
            <button style={modalButtonStyle} onClick={() => setSelectedMeeting(null)}>
              Close
            </button>
          </div>
        </div>
      )}

      {/* Fullscreen Image Viewer with Back button */}
      {fullscreenImage && (
        <div style={fullscreenOverlayStyle}>
          <button style={backButtonStyle} onClick={() => setFullscreenImage(null)}>
            Back
          </button>
          <img src={fullscreenImage} alt="Full view" style={fullscreenImageStyle} />
        </div>
      )}
    </div>
  );
}

// Styles
const thStyle = {
  borderBottom: '2px solid #ccc',
  padding: '12px 10px',
  textAlign: 'left',
  fontSize: '14px',
  fontWeight: '600',
};

const tdStyle = {
  
  padding: '10px',
  borderBottom: '1px solid #eee',
  fontSize: '14px',
};

const rowEvenStyle = {
  backgroundColor: '#ffffff',
};

const rowOddStyle = {
  backgroundColor: '#f9f9f9',
};

const buttonStyle = {
  color: '#fff',
  border: 'none',
  padding: '6px 12px',
  borderRadius: '4px',
  fontSize: '13px',
};

const modalOverlayStyle = {
  position: 'fixed',
  top: 0,
  left: 0,
  width: '100vw',
  height: '100vh',
  backgroundColor: 'rgba(0, 0, 0, 0.4)',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  zIndex: 1000,
  backdropFilter: 'blur(2px)',
};

const modalStyle = {
  backgroundColor: '#ffffff',
  padding: '30px 25px',
  borderRadius: '12px',
  width: '380px',
  maxHeight: '90vh',
  overflowY: 'auto',
  textAlign: 'left',
  boxShadow: '0 15px 30px rgba(0, 0, 0, 0.2)',
};

const modalButtonStyle = {
  padding: '10px 20px',
  borderRadius: '8px',
  border: 'none',
  backgroundColor: '#007bff',
  color: '#ffffff',
  fontSize: '15px',
  fontWeight: '500',
  cursor: 'pointer',
};

const fullscreenOverlayStyle = {
  position: 'fixed',
  top: 0,
  left: 0,
  width: '100vw',
  height: '100vh',
  backgroundColor: 'rgba(0,0,0,0.9)',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  zIndex: 2000,
  flexDirection: 'column',
};

const fullscreenImageStyle = {
  maxWidth: '90%',
  maxHeight: '90%',
  borderRadius: '10px',
};

const backButtonStyle = {
  position: 'fixed',
  top: '20px',
  left: '20px',
  padding: '10px 18px',
  fontSize: '16px',
  backgroundColor: 'rgba(255, 255, 255, 0.8)',
  border: 'none',
  borderRadius: '6px',
  cursor: 'pointer',
  zIndex: 2100, // higher than fullscreen image overlay
  boxShadow: '0 2px 8px rgba(0,0,0,0.3)',
};

export default Meetingpending;
